/**
 * This is a copy of the MenuList section from chakra-ui/menu
 * included here as we want to override the Animation (not possible with @chakra-ui/menu@1.8.6)
 */
import { useMenuContext, useMenuList, useMenuPositioner } from '@chakra-ui/menu';
import {
  chakra,
  forwardRef,
  HTMLChakraProps,
  PropsOf,
  useMultiStyleConfig,
} from '@chakra-ui/system';
import { CustomDomComponent, motion, Variants } from 'framer-motion';
import * as React from 'react';

export interface IDropdownListProps extends HTMLChakraProps<'div'> {
  rootProps?: HTMLChakraProps<'div'>;
}

const motionVariants: Variants = {
  enter: {
    visibility: 'visible',
    opacity: 1,
    // scale: 1,
    scaleX: 1,
    scaleY: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  exit: {
    transitionEnd: {
      visibility: 'hidden',
    },
    opacity: 0,
    scaleX: 1,
    scaleY: 1,
    transition: {
      duration: 0.1,
      easings: 'easeOut',
    },
  },
};

const MenuTransition: CustomDomComponent<PropsOf<typeof chakra.div>> = motion(chakra.div);

export const DropdownList = forwardRef<IDropdownListProps, 'div'>((props, ref) => {
  const { rootProps, ...rest } = props;

  const { isOpen, onTransitionEnd } = useMenuContext();

  const ownProps = useMenuList(rest, ref);
  const positionerProps = useMenuPositioner(rootProps);
  const styles = useMultiStyleConfig('Dropdown', props);

  return (
    <chakra.div
      {...positionerProps}
      __css={{ zIndex: props.zIndex ?? styles.list.zIndex, minW: 'unset!important' }}
    >
      <MenuTransition
        {...ownProps}
        __css={{
          outline: 0,
          ...styles.list,
        }}
        animate={isOpen ? 'enter' : 'exit'}
        initial={false}
        onUpdate={onTransitionEnd}
        variants={motionVariants}
      />
    </chakra.div>
  );
});
